<script lang="ts">
	import './styles.css';
	import Header from './ui/Header.svelte';
    import Footer from './ui/Footer.svelte';
  import { onMount } from 'svelte';
  import ContentRenderer from '$lib/components/ContentRenderer.svelte';
	interface Props {
		children?: import('svelte').Snippet;
	}

	let { children, data }: Props = $props();

	let alertDisplayed = $state(false);

	onMount(() => {
		const lastTime = sessionStorage.getItem('last-alert-time');
		if(lastTime && parseInt(lastTime) === data.alert.content.time) {
			return;
		}

		alertDisplayed = data.alert.visible;
	});

	function closeAlert() {
		alertDisplayed = false;
		sessionStorage.setItem('last-alert-time', data.alert.content.time.toString());
	}
</script>

<div class="app">
	<Header />

	<main>
		{#if alertDisplayed} 
			<aside class="special-alert">
				<div class="container special-alert__content">
					<button class="special-alert__close-btn" onclick={closeAlert}>
						<span class="material-symbols-outlined">
							close
						</span>
					</button>
					
					<ContentRenderer value={data.alert.content} />
				</div>
				
			</aside>
		{/if}
		
		{@render children?.()}
	</main>

	<Footer />
</div>

<style>
	.app {
		display: flex;
		flex-direction: column;
		min-height: 100vh;
	}

	main {
		padding-top: var(--header-height);
	}

	.special-alert {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.5);
		z-index: 10000;
	}

	.special-alert__top {
		font-size: 1.5rem;
	}

	.special-alert__content {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		background-color: #fff;
		padding: 2rem;
		border-radius: 8px;
	}

	.special-alert__close-btn {
		position: absolute;
		top: 1rem;
		right: 1rem;
		background: none;
		border: none;
		font-size: 1.5rem;
		cursor: pointer;
	}
</style>
